"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Graf = void 0;
const react_1 = __importStar(require("react"));
const typestyle_1 = require("typestyle");
const vars_1 = require("../vars");
const panzoom_1 = __importDefault(require("panzoom"));
const index_1 = require("./DOM/index");
const PaintNodes_1 = require("./PaintNodes");
const index_2 = require("./Node/index");
const trees_1 = require("../state/containers/trees");
const index_3 = require("../state/containers/index");
const Colors_1 = require("../Colors");
const Wrapper = typestyle_1.style({
    width: '100%',
    height: '100%',
    overflowX: 'hidden',
    position: 'relative',
    background: `#0b050d`,
    overflowY: 'auto',
});
const Main = typestyle_1.style({
    width: '100%',
    height: '100%',
    position: 'relative',
    fontFamily: vars_1.fontFamily,
    backgroundSize: `100px 100px`,
    backgroundImage: `linear-gradient(to right, #ffffff04 1px, transparent 1px), linear-gradient(to bottom, #ffffff04 1px, transparent 1px)`,
});
const Focus = typestyle_1.style({
    position: 'absolute',
});
const ErrorLock = typestyle_1.style({
    width: '100%',
    height: '100%',
    position: 'absolute',
    top: 0,
    left: 0,
    background: `${Colors_1.Colors.main[9]}99`,
    cursor: 'pointer',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
});
const ErrorLockMessage = typestyle_1.style({
    width: `clamp(200px,50vw,500px)`,
    fontFamily: vars_1.fontFamily,
    fontSize: 14,
    padding: 30,
    color: Colors_1.Colors.red[0],
    background: Colors_1.Colors.main[10],
});
let snapLock = true;
exports.Graf = () => {
    const [grafRef, setGrafRef] = react_1.useState(null);
    const wrapperRef = react_1.useRef(null);
    const [panRef, setPanRef] = react_1.useState();
    const { libraryTree, tree, setTree, selectedNode, setSelectedNode, selectedNodeRef, position, setSnapshots, snapshots, past, future, readonly, } = trees_1.useTreesState();
    const { lockGraf } = index_3.useErrorsState();
    const { setMenuState } = index_3.useNavigationState();
    const { setActions } = index_3.useIOState();
    react_1.useEffect(() => {
        if (grafRef && wrapperRef.current && !panRef) {
            const instance = panzoom_1.default(grafRef, {
                maxZoom: 1,
                minZoom: 1,
                enableTextSelection: true,
                disableKeyboardInteraction: true,
                zoomDoubleClickSpeed: 1,
                beforeMouseDown: (e) => {
                    return index_1.DOM.panLock;
                },
                beforeWheel: (e) => {
                    return true;
                },
                filterKey: () => {
                    return index_1.DOM.keyLock;
                },
                onDoubleClick: (e) => {
                    return false;
                },
            });
            instance.on('panstart', () => (index_1.DOM.lock = true));
            instance.on('panend', (e) => {
                setTimeout(() => (index_1.DOM.lock = false), 1);
            });
            instance.on('zoomstart', () => (index_1.DOM.lock = true));
            instance.on('zoomend', (e) => {
                setTimeout(() => (index_1.DOM.lock = false), 1);
            });
            setPanRef(instance);
        }
        if (!grafRef) {
            panRef === null || panRef === void 0 ? void 0 : panRef.dispose();
        }
        return () => {
            panRef === null || panRef === void 0 ? void 0 : panRef.dispose();
            setPanRef(undefined);
        };
    }, [grafRef]);
    react_1.useEffect(() => {
        var _a, _b;
        if (selectedNodeRef.current) {
            const n = selectedNodeRef.current;
            const nodePosition = n.getBoundingClientRect();
            (_a = wrapperRef.current) === null || _a === void 0 ? void 0 : _a.scrollTo({
                top: nodePosition.top + (((_b = wrapperRef.current) === null || _b === void 0 ? void 0 : _b.scrollTop) || 0) - wrapperRef.current.offsetHeight / 4.0,
                behavior: 'smooth',
            });
            if (nodePosition && panRef && wrapperRef.current) {
                const distanceVector = {
                    x: wrapperRef.current.getBoundingClientRect().left +
                        -nodePosition.left +
                        wrapperRef.current.offsetLeft +
                        wrapperRef.current.offsetWidth / 2.0 -
                        nodePosition.width / 2.0,
                    y: -nodePosition.top +
                        wrapperRef.current.offsetTop +
                        wrapperRef.current.offsetHeight / 2.0 -
                        nodePosition.height / 2.0,
                };
                distanceVector;
            }
        }
    }, [position]);
    react_1.useEffect(() => {
        if (snapLock) {
            snapLock = false;
            return;
        }
        const copyTree = JSON.stringify(tree);
        if (snapshots.length === 0) {
            setSnapshots([copyTree]);
            return;
        }
        if (snapshots[snapshots.length - 1] !== copyTree) {
            setSnapshots([...snapshots, copyTree]);
        }
    }, [tree]);
    react_1.useEffect(() => {
        setActions((acts) => (Object.assign(Object.assign({}, acts), { [index_3.KeyboardActions.Undo]: () => {
                const p = past();
                if (p) {
                    snapLock = true;
                    setTree(JSON.parse(p));
                }
            }, [index_3.KeyboardActions.Redo]: () => {
                const f = future();
                if (f) {
                    snapLock = true;
                    setTree(JSON.parse(f));
                }
            } })));
    }, [snapshots]);
    let node;
    if (selectedNode) {
        node =
            tree.nodes.find((n) => n.name === selectedNode.name && n.data.type === selectedNode.data.type) ||
                libraryTree.nodes.find((n) => n.name === selectedNode.name && n.data.type === selectedNode.data.type);
    }
    return (react_1.default.createElement("div", { ref: wrapperRef, className: Wrapper, style: {
            cursor: grafRef ? 'grab' : 'auto',
        }, onClick: () => {
            if (index_1.DOM.lock)
                return;
            index_1.DOM.scrollLock = false;
            setSelectedNode(undefined);
        } },
        react_1.default.createElement("div", { className: Main }, !lockGraf && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(PaintNodes_1.PaintNodes, null),
            node && position && wrapperRef.current && (react_1.default.createElement("div", { className: Focus, ref: (r) => {
                    setGrafRef(r);
                }, style: {
                    top: position.offsetTop - 10,
                    left: position.offsetLeft - 10,
                } },
                react_1.default.createElement(index_2.ActiveNode, { readonly: readonly, onDelete: () => {
                        const deletedNode = tree.nodes.findIndex((n) => n.name === node.name);
                        const allNodes = [...tree.nodes];
                        allNodes.splice(deletedNode, 1);
                        setSelectedNode(undefined);
                        setTree({ nodes: allNodes });
                        index_1.DOM.panLock = false;
                    }, onDuplicate: () => {
                        const allNodes = [...tree.nodes];
                        allNodes.push(JSON.parse(JSON.stringify(Object.assign(Object.assign({}, node), { name: (node === null || node === void 0 ? void 0 : node.name) + 'Copy' }))));
                        setTree({ nodes: allNodes });
                    }, node: node })))))),
        lockGraf && (react_1.default.createElement("div", { className: ErrorLock, onClick: () => {
                setMenuState('code-diagram');
            } },
            react_1.default.createElement("div", { className: ErrorLockMessage }, `Unable to parse GraphQL code. Graf editor is locked. Open "<>" code editor to correct errors in GraphQL Schema`)))));
};
